package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.Regex.NIKUD_CHARS
import com.eladfinish.bible.contest.extensions.replaceRegex

class RemoveNikudAndTeamimAndMakafUseCase {

    operator fun invoke(pasuk: String): String =
        pasuk
            .replaceRegex(
                regex = StringConstants.Regex.TEAMIM_CHARS,
                replacement = ""
            )
            .replaceRegex(
                regex = "${StringConstants.SPACE_OR_NO_BREAK_SPACE}+",
                replacement = " "
            )
            .replaceRegex(
                regex = NIKUD_CHARS,
                replacement = ""
            ) //.replaceRegex("\\s", " ")
            .replaceRegex(
                regex = "־",
                replacement = " "
            )
            .trim()

}
